import React from 'react';
import {
  PreleadCustomizeItemDate,
  ClientPreleadCustomizeItem,
  Prelead,
  useUpdatePreleadCustomizeItemDateMutation,
} from 'api';
import {DatePicker as UIDatePicker} from 'components/antd';
import styled from 'styled-components';
import moment from 'moment';

interface Props {
  prelead: Prelead;
  clientPreleadCustomizeItem: ClientPreleadCustomizeItem;
}

export default ({prelead, clientPreleadCustomizeItem}: Props) => {
  const customizeItem = prelead.customizeItemDates.find(
    (item: PreleadCustomizeItemDate) =>
      item.clientPreleadCustomizeItemId === clientPreleadCustomizeItem.id,
  );

  const [value, setValue] = React.useState(
    customizeItem ? moment(customizeItem.value) : null,
  );

  const [updateCustomizeItem] = useUpdatePreleadCustomizeItemDateMutation();

  const update = (value: Date) => {
    updateCustomizeItem({
      variables: {
        uuid: prelead.uuid,
        clientPreleadCustomizeItemId: clientPreleadCustomizeItem.id,
        value,
      },
    });
  };

  React.useEffect(() => {
    setValue(customizeItem ? moment(customizeItem.value) : null);
  }, [customizeItem]);

  React.useEffect(() => {
    update(value ? value.toDate() : null);
  }, [value]);

  return (
    <DatePicker
      allowClear
      onChange={setValue}
      placeholder="未入力"
      value={value}
      style={{width: '100%'}}
    />
  );
};

const DatePicker = styled(UIDatePicker)`
  border-color: transparent;
  background-color: transparent;
  border-radius: 4px;

  &:hover {
    border: 1px solid var(--text-color-3);
  }
`;
